import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import store from "./redux/store";
import "./globalStyles.css";
import reportWebVitals from "./reportWebVitals";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./pages/Login/authConfig";
import MainRoutes from "./routes/index";
import "./i18n";
// Check if the sessionStorage is set for this session
const isFirstVisitInSession = !sessionStorage.getItem("visited");

// If it's a fresh visit in this session, mark the session as visited and force reload
if (isFirstVisitInSession) {
  sessionStorage.setItem("visited", "true"); // Mark session as visited
  window.location.reload(); // Reload the page to simulate "fresh" page load
} else {
  // Proceed with normal rendering on subsequent visits in the same session
  const root = ReactDOM.createRoot(document.getElementById("root"));

  const msalInstance = new PublicClientApplication(msalConfig);
  root.render(
    <Provider store={store}>
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <MainRoutes />
        </MsalProvider>
      </React.StrictMode>
    </Provider>
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
}
